// // // client/src/services/api.js
// // const API_BASE =
// //   (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_BASE) ||
// //   (typeof process !== "undefined" && process.env?.REACT_APP_API_BASE) ||
// //   "http://192.168.236.216:3002"; // NUC fallback

// // async function jsonFetch(path, opts = {}) {
// //   const res = await fetch(`${API_BASE}${path}`, {
// //     ...opts,
// //     headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
// //   });
// //   if (!res.ok) {
// //     let msg = `${res.status} ${res.statusText}`;
// //     try { const j = await res.json(); msg = j.error || msg; } catch {}
// //     throw new Error(msg);
// //   }
// //   return res.json();
// // }

// // export function fetchLatest(devEui) {
// //   return devEui ? jsonFetch(`/api/thermostat/${devEui}/latest`)
// //                 : jsonFetch(`/api/thermostat/latest`);
// // }

// // export function fetchHistory(devEui) {
// //   return devEui ? jsonFetch(`/api/thermostat/${devEui}/history`)
// //                 : jsonFetch(`/api/thermostat/history`);
// // }

// // export function setFanMode(newMode, devEui) {
// //   return jsonFetch(
// //     devEui ? `/api/thermostat/${devEui}/fanmode` : `/api/thermostat/fanmode`,
// //     { method: "POST", body: JSON.stringify({ mode: String(newMode).toLowerCase() }) }
// //   );
// // }

// // export function setControlMode(newMode, devEui) {
// //   return jsonFetch(
// //     devEui
// //       ? `/api/thermostat/${devEui}/mode`   // <-- use /mode
// //       : `/api/thermostat/mode`,
// //     { method: "POST", body: JSON.stringify({ mode: newMode }) }
// //   );
// // }


// // export function setTargetTemperature(newTemp, devEui) {
// //   return jsonFetch(
// //     devEui ? `/api/thermostat/${devEui}/setpoint` : `/api/thermostat/setpoint`,
// //     { method: "POST", body: JSON.stringify({ temperature: Number(newTemp) }) }
// //   );
// // }

// // export { API_BASE };


// // src/services/api.js
// const API_BASE =
//   import.meta.env?.VITE_API_BASE ||
//   process.env?.REACT_APP_API_BASE ||
//   "http://192.168.236.216:3002";

// async function jsonFetch(path, opts = {}) {
//   const res = await fetch(`${API_BASE}${path}`, {
//     ...opts,
//     headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
//   });
//   if (!res.ok) {
//     let msg = `${res.status} ${res.statusText}`;
//     try {
//       const j = await res.json();
//       msg = j.error || msg;
//     } catch {}
//     throw new Error(msg);
//   }
//   return res.json();
// }

// // Devices
// export const fetchDevices = () => jsonFetch(`/api/devices`);

// // Thermostat
// export const fetchLatest = (devEui) => jsonFetch(`/api/thermostat/${devEui}/latest`);
// export const fetchHistory = (devEui) => jsonFetch(`/api/thermostat/${devEui}/history`);
// export const setFanMode = (mode, devEui) =>
//   jsonFetch(`/api/thermostat/${devEui}/fanmode`, {
//     method: "POST",
//     body: JSON.stringify({ mode: String(mode).toLowerCase() }),
//   });
// export const setControlMode = (mode, devEui) =>
//   jsonFetch(`/api/thermostat/${devEui}/mode`, {
//     method: "POST",
//     body: JSON.stringify({ mode }),
//   });
// export const setTargetTemperature = (t, devEui) =>
//   jsonFetch(`/api/thermostat/${devEui}/setpoint`, {
//     method: "POST",
//     body: JSON.stringify({ temperature: Number(t) }),
//   });

// // Saya water
// export const fetchSayaFlowLatest = (devEui) =>
//   jsonFetch(`/api/saya/${devEui}/flow/latest`);
// export const fetchSayaFlowHistory = (devEui) =>
//   jsonFetch(`/api/saya/${devEui}/flow/history`);
// export const fetchSayaStatusLatest = (devEui) =>
//   jsonFetch(`/api/saya/${devEui}/status/latest`);

// // Leak
// export const fetchLeakLatest = (devEui) =>
//   jsonFetch(`/api/leak/${devEui}/latest`);
// export const fetchLeakHistory = (devEui) =>
//   jsonFetch(`/api/leak/${devEui}/history`);

// // Air Quality
// export const fetchAirLatest = (devEui) =>
//   jsonFetch(`/api/air/${devEui}/latest`);
// export const fetchAirHistory = (devEui) =>
//   jsonFetch(`/api/air/${devEui}/history`);

// export { API_BASE };




// src/services/api.js

// Order of precedence for API base:
// 1) localStorage.API_BASE (runtime override)
// 2) Vite env (VITE_API_BASE)
// 3) CRA env (REACT_APP_API_BASE)
// 4) Hardcoded fallback (edit this to your usual backend)
// 4) Hardcoded fallback (edit this to your usual backend)
// Determine API base URL with a single convention:
// - On canonical IoT domains, use same-origin `/iot/api` (avoids CORS entirely).
// - On localhost, use local central server directly.
// - Otherwise, fall back to explicit backend host for LAN debugging.
const getDefaultApiBase = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol; // Use same protocol (http/https)
    
    // If accessing from localhost/127.0.0.1, use localhost for API (same machine)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return "http://localhost:3001";
    }
    
    // Production IoT domains: use routed API origins (never `/control`; paths use `/api/...`).
    if (
      hostname === 'iot.smarterbuildings.ca' ||
      hostname.includes('smarterbuildings.ca') ||
      hostname === 'iot.smart-buildings.ca' ||
      hostname === 'iot.smarterbuildings.ca'
    ) {
      return hostname.includes('smarterbuildings.ca')
        ? `${protocol}//iot.smarterbuildings.ca`
        : `${protocol}//iot.smart-buildings.ca`;
    }
    
    // For all other hosts (including IP addresses), use network IP
    return "http://192.168.236.152:3001";
  }
  return "http://192.168.236.152:3001";
};

// Check if we're on the canonical IoT dashboard domains.
const isIotDashboard = typeof window !== "undefined" && (
  window.location.hostname === 'iot.smarterbuildings.ca' ||
  window.location.hostname.includes('smarterbuildings.ca') ||
  window.location.hostname === 'iot.smart-buildings.ca' ||
  window.location.hostname === 'iot.smarterbuildings.ca'
);

// On production IoT domains, force the routed API base and ignore conflicting build-time env.
const buildTimeApiBase = import.meta.env?.VITE_API_BASE || process.env?.REACT_APP_API_BASE;
const defaultApiBase = getDefaultApiBase();

let API_BASE;
if (isIotDashboard) {
  API_BASE = getDefaultApiBase(); // Always same-origin host for canonical dashboard domains
} else {
  const shouldUseBuildTime = buildTimeApiBase &&
    !buildTimeApiBase.includes(':3002') &&
    !buildTimeApiBase.includes('192.168.236.216');
  API_BASE = shouldUseBuildTime ? buildTimeApiBase : defaultApiBase;
}

// Final safety: never use /control (causes 404/503)
if (typeof API_BASE === 'string' && API_BASE.includes("/control")) {
  API_BASE = API_BASE.replace("/control", "/central");
  console.warn("[API] Corrected /control → /central");
}

// Clear old localStorage API_BASE that pointed to backend or wrong path
if (typeof window !== "undefined" && window.localStorage) {
  const stored = window.localStorage.getItem("API_BASE");
  const shouldClear = stored && (
    stored.includes(":3002") ||
    stored.includes("192.168.236.216") ||
    stored.includes("/control")
  );
  if (shouldClear) {
    console.warn("Removing invalid API_BASE from localStorage:", stored);
    window.localStorage.removeItem("API_BASE");
  }
}

// DEBUG: Log the API_BASE being used (remove in production)
if (typeof window !== "undefined") {
  const isHttps = window.location.protocol === 'https:';
  const apiIsHttps = API_BASE.startsWith('https://');
  
  console.log("🔍 [API] Using API_BASE:", API_BASE);
  console.log("🔍 [API] Page protocol:", window.location.protocol);
  console.log("🔍 [API] API protocol:", API_BASE.split('://')[0] + '://');
  
  if (API_BASE.includes(":3002")) {
    console.error("❌ [API] ERROR: API_BASE points to backend! Should point to central server (port 3001)");
  } else if (API_BASE.includes(":3001")) {
    console.log("✅ [API] API_BASE correctly points to central server");
  }
  
  // Check for mixed content issues
  if (isHttps && !apiIsHttps && !API_BASE.includes('localhost') && !API_BASE.includes('127.0.0.1')) {
    console.error("❌ [API] MIXED CONTENT ERROR: Page is HTTPS but API_BASE is HTTP!");
    console.error("   This will be blocked by the browser. API must use HTTPS for production.");
    console.error("   Current API_BASE:", API_BASE);
    console.error("   Fix: Configure API to use HTTPS or set VITE_API_BASE environment variable");
  }
  
  // On canonical hosts, API should be same-origin (/iot/api), so CORS should not apply.
}

// Simple in-memory + sessionStorage-backed API log store
const MAX_LOG_ENTRIES = 500;
let apiLogs = [];

function loadLogsFromSession() {
  if (apiLogs.length || typeof window === "undefined" || !window.sessionStorage) return;
  try {
    const raw = window.sessionStorage.getItem("iotApiLogs");
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        apiLogs = parsed;
      }
    }
  } catch {
    // ignore parse errors
  }
}

function persistLogsToSession() {
  if (typeof window === "undefined" || !window.sessionStorage) return;
  try {
    // Persist only the most recent 200 to avoid huge payloads
    window.sessionStorage.setItem("iotApiLogs", JSON.stringify(apiLogs.slice(0, 200)));
  } catch {
    // ignore quota errors
  }
}

function recordApiLog(entry) {
  loadLogsFromSession();
  const enriched = {
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    timestamp: new Date().toISOString(),
    ...entry,
  };
  apiLogs.unshift(enriched);
  if (apiLogs.length > MAX_LOG_ENTRIES) {
    apiLogs.length = MAX_LOG_ENTRIES;
  }
  persistLogsToSession();
}

export function getApiLogs() {
  loadLogsFromSession();
  return apiLogs;
}

export function clearApiLogs() {
  apiLogs = [];
  if (typeof window !== "undefined" && window.sessionStorage) {
    try {
      window.sessionStorage.removeItem("iotApiLogs");
    } catch {
      // ignore
    }
  }
}

// --- Dashboard / client activity logs (non-API): errors, auth events, etc. ---
const MAX_DASHBOARD_LOG_ENTRIES = 400;
let dashboardActivityLogs = [];

function loadDashboardLogsFromSession() {
  if (dashboardActivityLogs.length || typeof window === "undefined" || !window.sessionStorage) return;
  try {
    const raw = window.sessionStorage.getItem("iotDashboardLogs");
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        dashboardActivityLogs = parsed;
      }
    }
  } catch {
    // ignore
  }
}

function persistDashboardLogsToSession() {
  if (typeof window === "undefined" || !window.sessionStorage) return;
  try {
    window.sessionStorage.setItem(
      "iotDashboardLogs",
      JSON.stringify(dashboardActivityLogs.slice(0, 200))
    );
  } catch {
    // ignore quota
  }
}

/**
 * Record a non-API dashboard event (runtime errors, auth, navigation hooks, etc.).
 * @param {{ level?: string, category?: string, message: string, detail?: string }} entry
 */
export function recordDashboardLog(entry) {
  if (typeof window === "undefined" || !entry?.message) return;
  loadDashboardLogsFromSession();
  const enriched = {
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    timestamp: new Date().toISOString(),
    level: entry.level || "info",
    category: entry.category || "Dashboard",
    message: entry.message,
    detail: entry.detail != null ? String(entry.detail) : undefined,
    logKind: "app",
  };
  dashboardActivityLogs.unshift(enriched);
  if (dashboardActivityLogs.length > MAX_DASHBOARD_LOG_ENTRIES) {
    dashboardActivityLogs.length = MAX_DASHBOARD_LOG_ENTRIES;
  }
  persistDashboardLogsToSession();
}

export function getDashboardActivityLogs() {
  loadDashboardLogsFromSession();
  return dashboardActivityLogs;
}

/** API traffic + dashboard activity, newest first */
export function getUnifiedLogs() {
  const api = getApiLogs().map((e) => ({ ...e, logKind: "api" }));
  const app = getDashboardActivityLogs().map((e) => ({ ...e, logKind: e.logKind || "app" }));
  return [...api, ...app].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
}

/** Clear both API and dashboard activity buffers (one session). */
export function clearAllSessionLogs() {
  clearApiLogs();
  dashboardActivityLogs = [];
  if (typeof window !== "undefined" && window.sessionStorage) {
    try {
      window.sessionStorage.removeItem("iotDashboardLogs");
    } catch {
      // ignore
    }
  }
}

let dashboardListenersInstalled = false;

/** Capture window errors, unhandled rejections, and auth events for the “All activity” log view. */
export function installDashboardLogListeners() {
  if (typeof window === "undefined" || dashboardListenersInstalled) return;
  dashboardListenersInstalled = true;

  window.addEventListener(
    "error",
    (ev) => {
      recordDashboardLog({
        level: "error",
        category: "JavaScript",
        message: ev.message || "Error",
        detail: ev.error?.stack || (ev.filename ? `${ev.filename}:${ev.lineno}:${ev.colno}` : undefined),
      });
    },
    true
  );

  window.addEventListener("unhandledrejection", (ev) => {
    const reason = ev.reason;
    recordDashboardLog({
      level: "error",
      category: "Promise",
      message: reason?.message ? String(reason.message) : String(reason),
      detail: reason?.stack,
    });
  });

  window.addEventListener("iot-auth-expired", () => {
    recordDashboardLog({
      level: "warn",
      category: "Auth",
      message: "Session expired or token rejected (sign in again from Central Auth)",
    });
  });

  recordDashboardLog({
    level: "info",
    category: "Session",
    message: "IoT dashboard client started (unified log capture active)",
  });
}

// Matches `/control` only as a complete path segment, so routes such as
// `/api/controllers` are left alone.
const CONTROL_SEGMENT = /\/control(?=[/?#]|$)/g;

function toCentralSegment(url) {
  return url.replace(CONTROL_SEGMENT, "/central");
}

/** Same URL rules as jsonFetch: trim trailing slash on base, /control → /central. */
function buildApiUrl(path) {
  const base = String(API_BASE || "").replace(/\/$/, "");
  let p = path.startsWith("/") ? path : `/${path}`;

  // Production IoT host: nginx forwards /iot/api/* to central server (not bare /api/*).
  if (typeof window !== "undefined" && isIotDashboard && !base.includes("/iot/api")) {
    const apiPath = p.startsWith("/api/") ? p.slice(4) : p;
    return toCentralSegment(
      `${base}/iot/api${apiPath.startsWith("/") ? apiPath : `/${apiPath}`}`
    );
  }

  return toCentralSegment(`${base}${p}`);
}

async function jsonFetch(path, opts = {}) {
  const builtUrl = buildApiUrl(path);
  // Runtime safety: /control does not exist in Nginx, always use /central
  const url = toCentralSegment(builtUrl);
  if (url !== builtUrl) {
    console.warn("[API] Runtime fix: /control → /central for", path);
  }
  const method = (opts.method || "GET").toUpperCase();
  const startedAt = Date.now();
  try {
  
  // Get auth token from localStorage
  const token = typeof window !== "undefined" ? localStorage.getItem("authToken") : null;
  
  // Build headers with auth token if available
  const headers = {
    "Content-Type": "application/json",
    ...(opts.headers || {}),
  };
  
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  
  // DEBUG: Log all API calls
  if (typeof window !== "undefined") {
    console.log(`🌐 [API] ${method} ${url}`);
  }
  
  const res = await fetch(url, {
    ...opts,
    headers,
    credentials: opts.credentials || "include",
  });
  
  // If request was aborted (e.g. user switched device), let caller handle it
  if (res.body && opts.signal?.aborted) {
    const e = new Error('Request aborted');
    e.name = 'AbortError';
    throw e;
  }
  
  const status = res.status;

  // Handle 401 Unauthorized
  if (res.status === 401) {
    // Clear auth. Do NOT reload — that leaves the app with no token and retriggers the
    // "redirect to central auth" path repeatedly (redirect loop after idle/session expiry).
    // App.js listens for `iot-auth-expired` and shows Session Expired + link to central auth.
    if (typeof window !== "undefined") {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("loginTime");
      const now = Date.now();
      const last = Number(sessionStorage.getItem("iot401LastDispatch") || 0);
      if (now - last > 1500) {
        sessionStorage.setItem("iot401LastDispatch", String(now));
        window.dispatchEvent(new CustomEvent("iot-auth-expired"));
      }
    }
    const err = new Error("Session expired. Please log in again.");
    recordApiLog({
      level: "error",
      scope: "auth",
      method,
      path,
      url,
      status,
      durationMs: Date.now() - startedAt,
      message: err.message,
    });
    throw err;
  }
  
  // Handle 403 Forbidden - read-only access
  if (res.status === 403) {
    let msg = "Read-only access: You cannot control devices with your current account.";
    try {
      const j = await res.json();
      msg = j.message || j.error || msg;
    } catch {}
    const err = new Error(msg);
    recordApiLog({
      level: "warn",
      scope: "api",
      method,
      path,
      url,
      status,
      durationMs: Date.now() - startedAt,
      message: err.message,
    });
    throw err;
  }
  
  if (!res.ok) {
    let msg = `${res.status} ${res.statusText}`;
    try {
      const j = await res.json();
      const detail = j.message || j.error;
      // Keep status prefix so errorMessages.js can detect 404/503/etc. (j.error alone may be e.g. "not_configured")
      msg = detail ? `${res.status} ${detail}` : msg;
    } catch {}
    const err = new Error(msg);
    recordApiLog({
      level: "error",
      scope: "api",
      method,
      path,
      url,
      status,
      durationMs: Date.now() - startedAt,
      message: err.message,
    });
    throw err;
  }
  // handle empty responses
  try {
    const json = await res.json();
    recordApiLog({
      level: "info",
      scope: "api",
      method,
      path,
      url,
      status,
      durationMs: Date.now() - startedAt,
      message: "OK",
    });
    return json;
  } catch {
    // No JSON body
    recordApiLog({
      level: "info",
      scope: "api",
      method,
      path,
      url,
      status,
      durationMs: Date.now() - startedAt,
      message: "OK (no JSON body)",
    });
    return null;
  }
} catch (err) {
  if (err?.name === 'AbortError' || (err instanceof DOMException && err.name === 'AbortError')) {
    throw err; // Let caller ignore aborted requests
  }
  recordApiLog({
    level: "error",
    scope: "network",
    method,
    path,
    url,
    status: null,
    durationMs: Date.now() - startedAt,
    message: err?.message || String(err),
  });
  throw err;
}
}

// ----------------- Buildings -----------------
export const fetchBuildings = () => jsonFetch(`/api/buildings`);

/**
 * Per-building WebSocket link: is each building's backend connected to the central server?
 * Level 5 only. Returns { serverTime, totalConnected, buildings: [{ buildingId, name,
 * backendConnected, connectedAt }] }
 */
export const fetchBackendConnectivity = (opts = {}) =>
  jsonFetch(`/api/buildings/connectivity`, opts);

// ----------------- Alarms -----------------
/** Building defaults + emails + devices[{devEui,category,override,effective}] */
export const getAlarmConfig = (buildingId) =>
  jsonFetch(`/api/alarms/config/${encodeURIComponent(buildingId)}`).catch(() => null);

/**
 * Save building defaults/emails. Optional applyThermostatTo / applySpaceTo / applyLeakTo
 * arrays upsert per-device overrides for the selected DevEUIs.
 */
export const putAlarmConfig = (buildingId, config) =>
  jsonFetch(`/api/alarms/config/${encodeURIComponent(buildingId)}`, {
    method: "PUT",
    body: JSON.stringify(config),
  });

/** Alarm emails recently sent (per device/type), scoped to buildings you can access */
export const getAlarmTriggers = (buildingId) => {
  const q =
    buildingId && buildingId !== "all"
      ? `?buildingId=${encodeURIComponent(buildingId)}`
      : "";
  return jsonFetch(`/api/alarms/triggers${q}`);
};

// ----------------- Devices -----------------
export const fetchDevices = () => jsonFetch(`/api/devices`);
export const deleteDevice = (devEui) =>
  jsonFetch(`/api/devices/${encodeURIComponent(devEui)}`, {
    method: "DELETE",
  });

/** Set or clear a device's in-building location label (level 4+). Pass "" / null to clear. */
export const putDeviceLocation = (devEui, location) =>
  jsonFetch(`/api/devices/${encodeURIComponent(devEui)}/location`, {
    method: "PUT",
    body: JSON.stringify({
      location: location == null || String(location).trim() === "" ? null : String(location).trim(),
    }),
  });

// ----------------- Thermostat core -----------------
export const fetchLatest = (devEui, opts = {}) =>
  jsonFetch(`/api/thermostat/${encodeURIComponent(devEui)}/latest`, opts);

export const fetchHistory = (devEui, options = {}) => {
  const params = new URLSearchParams();
  // Default to all data if no options specified
  if (options.all === true) {
    // Request all available data - no limit
    params.append('all', 'true');
  } else if (options.days != null) {
    params.append('days', String(options.days));
  } else {
    // Default to all data - no limits
    params.append('all', 'true');
  }
  if (options.startDate) {
    params.append('startDate', options.startDate);
  }
  if (options.endDate) {
    params.append('endDate', options.endDate);
  }
  const queryString = params.toString();
  return jsonFetch(`/api/thermostat/${encodeURIComponent(devEui)}/history${queryString ? '?' + queryString : ''}`);
};

export const setFanMode = (mode, devEui) =>
  jsonFetch(`/api/thermostat/${encodeURIComponent(devEui)}/fanmode`, {
    method: "POST",
    body: JSON.stringify({ mode: String(mode).toLowerCase() }),
  });

export const setControlMode = (mode, devEui) =>
  jsonFetch(`/api/thermostat/${encodeURIComponent(devEui)}/mode`, {
    method: "POST",
    body: JSON.stringify({ mode }),
  });

export const setTargetTemperature = (t, devEui) =>
  jsonFetch(`/api/thermostat/${encodeURIComponent(devEui)}/setpoint`, {
    method: "POST",
    body: JSON.stringify({ temperature: Number(t) }),
  });

// ----------------- Thermostat schedules -----------------
// Backend routes assumed:
//   GET    /api/thermostat/:devEui/schedules
//   POST   /api/thermostat/:devEui/schedules         { at: ISOString, setpointC, enabled? }
//   PUT    /api/thermostat/:devEui/schedules/:id     partial updates
//   DELETE /api/thermostat/:devEui/schedules/:id
export const getSchedules = (devEui) =>
  jsonFetch(`/api/thermostat/${encodeURIComponent(devEui)}/schedules`);

export const createSchedule = (devEui, schedule) =>
  jsonFetch(`/api/thermostat/${encodeURIComponent(devEui)}/schedules`, {
    method: "POST",
    body: JSON.stringify(schedule),
  });

export const updateSchedule = (devEui, id, patch) =>
  jsonFetch(
    `/api/thermostat/${encodeURIComponent(devEui)}/schedules/${encodeURIComponent(id)}`,
    { method: "PUT", body: JSON.stringify(patch) }
  );

export const deleteSchedule = (devEui, id) =>
  jsonFetch(
    `/api/thermostat/${encodeURIComponent(devEui)}/schedules/${encodeURIComponent(id)}`,
    { method: "DELETE" }
  );

// ----------------- Saya water -----------------
export const fetchSayaFlowLatest = (devEui, opts = {}) =>
  jsonFetch(`/api/saya/${encodeURIComponent(devEui)}/flow/latest`, opts);
export const fetchSayaFlowHistory = (devEui, options = {}) => {
  const params = new URLSearchParams();
  // Default to all data if no options specified
  if (options.all === true) {
    params.append('all', 'true');
  } else if (options.days != null) {
    params.append('days', String(options.days));
  } else {
    // Default to all data - no limits
    params.append('all', 'true');
  }
  if (options.startDate) {
    params.append('startDate', options.startDate);
  }
  if (options.endDate) {
    params.append('endDate', options.endDate);
  }
  const queryString = params.toString();
  return jsonFetch(`/api/saya/${encodeURIComponent(devEui)}/flow/history${queryString ? '?' + queryString : ''}`);
};
export const fetchSayaStatusLatest = (devEui, opts = {}) =>
  jsonFetch(`/api/saya/${encodeURIComponent(devEui)}/status/latest`, opts);

// ----------------- Leak -----------------
export const fetchLeakLatest = (devEui, opts = {}) =>
  jsonFetch(`/api/leak/${encodeURIComponent(devEui)}/latest`, opts);

export const fetchLeakHistory = (devEui, options = {}) => {
  const { signal, ...rest } = options;
  const params = new URLSearchParams();

  // Range / size controls
  // - If caller explicitly asks for all: true, honour it (may be heavy)
  // - If caller passes days, use that
  // - If caller passes explicit dates, let the server use start/end only
  // - Otherwise, default to the last 30 days to keep responses manageable
  if (rest.all === true) {
    params.append('all', 'true');
  } else if (rest.days != null) {
    params.append('days', String(rest.days));
  } else if (!rest.startDate && !rest.endDate) {
    // Safe default: last 30 days
    params.append('days', '30');
  }

  if (rest.startDate) {
    params.append('startDate', rest.startDate);
  }
  if (rest.endDate) {
    params.append('endDate', rest.endDate);
  }

  const queryString = params.toString();
  return jsonFetch(
    `/api/leak/${encodeURIComponent(devEui)}/history${queryString ? '?' + queryString : ''}`,
    { signal }
  );
};

// ----------------- TBHH100 (Healthy Home) -----------------
export const fetchTbhh100Latest = (devEui, opts = {}) =>
  jsonFetch(`/api/tbhh100/${encodeURIComponent(devEui)}/latest`, opts);
export const fetchTbhh100History = (devEui, options = {}) => {
  const params = new URLSearchParams();
  if (options.all === true) {
    params.append('all', 'true');
  } else if (options.limit != null) {
    params.append('limit', String(options.limit));
  } else {
    params.append('all', 'true');
  }
  if (options.startDate) {
    params.append('startDate', options.startDate);
  }
  if (options.endDate) {
    params.append('endDate', options.endDate);
  }
  const queryString = params.toString();
  return jsonFetch(`/api/tbhh100/${encodeURIComponent(devEui)}/history${queryString ? '?' + queryString : ''}`);
};

// ----------------- Ember -----------------
export const fetchEmberLatest = (devEui, opts = {}) =>
  jsonFetch(`/api/ember/${encodeURIComponent(devEui)}/latest`, opts);

export const fetchEmberHistory = (devEui, options = {}) => {
  const params = new URLSearchParams();
  if (options.all === true) {
    params.append("all", "true");
  } else if (options.limit != null) {
    params.append("limit", String(options.limit));
  } else {
    params.append("limit", "5000");
  }
  if (options.startDate) {
    params.append("startDate", options.startDate);
  }
  if (options.endDate) {
    params.append("endDate", options.endDate);
  }
  const queryString = params.toString();
  return jsonFetch(
    `/api/ember/${encodeURIComponent(devEui)}/history${queryString ? `?${queryString}` : ""}`,
    { signal: options.signal }
  );
};

// ----------------- Dragino -----------------
export const fetchDraginoLatest = (devEui, opts = {}) =>
  jsonFetch(`/api/dragino/${encodeURIComponent(devEui)}/latest`, opts);

export const fetchDraginoHistory = (devEui, options = {}) => {
  const params = new URLSearchParams();
  if (options.all === true) {
    params.append("all", "true");
  } else if (options.limit != null) {
    params.append("limit", String(options.limit));
  } else {
    params.append("limit", "5000");
  }
  if (options.startDate) {
    params.append("startDate", options.startDate);
  }
  if (options.endDate) {
    params.append("endDate", options.endDate);
  }
  const queryString = params.toString();
  return jsonFetch(
    `/api/dragino/${encodeURIComponent(devEui)}/history${queryString ? `?${queryString}` : ""}`,
    { signal: options.signal }
  );
};

// ----------------- Milesight Controller -----------------
export const fetchControllerLatest = (devEui, opts = {}) =>
  jsonFetch(`/api/milesight_controller/${encodeURIComponent(devEui)}/latest`, opts);

export const fetchControllerHistory = (devEui, options = {}) => {
  const params = new URLSearchParams({ limit: String(options.limit ?? 500) });
  return jsonFetch(
    `/api/milesight_controller/${encodeURIComponent(devEui)}/history?${params}`,
    { signal: options.signal }
  );
};

// ----------------- Milesight VS330 occupancy -----------------
export const fetchVs330Latest = (devEui, opts = {}) =>
  jsonFetch(`/api/vs330/${encodeURIComponent(devEui)}/latest`, opts);

export const fetchVs330History = (devEui, options = {}) => {
  const params = new URLSearchParams();
  if (options.limit != null) params.set("limit", String(options.limit));
  if (options.all) params.set("all", "true");
  if (options.occupancyOnly) params.set("occupancyOnly", "true");
  if (options.days != null) params.set("days", String(options.days));
  if (options.startDate) params.set("startDate", options.startDate);
  if (options.endDate) params.set("endDate", options.endDate);
  const queryString = params.toString();
  return jsonFetch(
    `/api/vs330/${encodeURIComponent(devEui)}/history${queryString ? `?${queryString}` : ""}`,
    { signal: options.signal }
  );
};

// ----------------- Air Quality -----------------
// Try multiple endpoint variations since backend might use different naming
export const fetchAirLatest = async (devEui, opts = {}) => {
  const { signal } = opts;
  const endpoints = [
    `/api/air/${encodeURIComponent(devEui)}/latest`,
    `/api/environment/${encodeURIComponent(devEui)}/latest`,
    `/api/sensor/${encodeURIComponent(devEui)}/latest`,
    `/api/iaq/${encodeURIComponent(devEui)}/latest`,
  ];

  for (const endpoint of endpoints) {
    if (signal?.aborted) {
      throw new DOMException("Aborted", "AbortError");
    }
    try {
      const result = await jsonFetch(endpoint, { signal });
      if (result) {
        console.log(`Air API endpoint found: ${endpoint}`);
        return result;
      }
    } catch (e) {
      if (e?.name === "AbortError") throw e;
      // If it's not a 404, re-throw (might be a real error)
      if (e.message && !e.message.includes("404")) {
        throw e;
      }
      // Otherwise, try next endpoint
      continue;
    }
  }

  // If all endpoints failed, throw the last error
  throw new Error(
    "404 Not Found - Air quality endpoint not found. Tried: /api/air, /api/environment, /api/sensor, /api/iaq"
  );
};

export const fetchAirHistory = async (devEui, options = {}) => {
  const params = new URLSearchParams();
  // Default to all data if no options specified
  if (options.all === true) {
    // Request all available data - no limit
    params.append('all', 'true');
  } else if (options.days != null) {
    params.append('days', String(options.days));
  } else {
    // Default to all data - no limits
    params.append('all', 'true');
  }
  if (options.startDate) {
    params.append('startDate', options.startDate);
  }
  if (options.endDate) {
    params.append('endDate', options.endDate);
  }
  const queryString = params.toString();
  
  const endpoints = [
    `/api/air/${encodeURIComponent(devEui)}/history${queryString ? '?' + queryString : ''}`,
    `/api/environment/${encodeURIComponent(devEui)}/history${queryString ? '?' + queryString : ''}`,
    `/api/sensor/${encodeURIComponent(devEui)}/history${queryString ? '?' + queryString : ''}`,
    `/api/iaq/${encodeURIComponent(devEui)}/history${queryString ? '?' + queryString : ''}`,
  ];
  
  for (const endpoint of endpoints) {
    try {
      const result = await jsonFetch(endpoint);
      if (result) {
        console.log(`Air history API endpoint found: ${endpoint}`);
        return result;
      }
    } catch (e) {
      // If it's not a 404, re-throw (might be a real error)
      if (e.message && !e.message.includes('404')) {
        throw e;
      }
      // Otherwise, try next endpoint
      continue;
    }
  }
  
  // If all endpoints failed, throw the last error
  throw new Error('404 Not Found - Air quality history endpoint not found. Tried: /api/air, /api/environment, /api/sensor, /api/iaq');
};

// ----------------- User Management (central auth org users via IoT proxy) -----------------
// Requires IOT_SERVICE_KEY on central server. Organization admins get their org;
// platform admins (internal level 5) get every organization, grouped in the UI.
export const getUsers = () => jsonFetch('/api/org-users');

/** Proxied to auth GET /admin/organizations (dashboard level 4+). Used for building→org assignment. */
export const getAdminOrganizations = () => jsonFetch('/api/admin/organizations');

export const putBuildingOrganization = (buildingId, organizationId) =>
  jsonFetch(`/api/admin/buildings/${encodeURIComponent(buildingId)}/organization`, {
    method: 'PUT',
    body: JSON.stringify({ organizationId: organizationId === undefined ? null : organizationId }),
  });

export const putBuildingLocation = (buildingId, address) =>
  jsonFetch(`/api/buildings/${encodeURIComponent(buildingId)}/location`, {
    method: 'PUT',
    body: JSON.stringify({ address }),
  });

const FLOOR_PLAN_NOT_ON_SERVER_MSG =
  "Floor plan is not available on the API yet (404). The host must deploy the latest iot-central-server (with /central/api/… or /api/buildings/…/floor-plan routes) and ensure Nginx forwards POST/GET to Node.";

/** Set to false to silence [floor-plan] console traces after debugging. */
const FLOOR_PLAN_DEBUG = true;

/**
 * Public floor-plan API URL. Must match express mounts: /api, /iot/api, and /central/api
 * (see iot-central-server/server.js) so the same path works behind different nginx rules.
 * buildingId: use `buildingid` from GET /api/buildings (string slug, e.g. 20BroadSt) — not display name.
 */
function getFloorPlanResourceUrl(buildingId, suffix = "") {
  const id = encodeURIComponent(String(buildingId ?? "").trim());
  const extra = suffix ? `/${String(suffix).replace(/^\//, "")}` : "";
  if (typeof window === "undefined") {
    return buildApiUrl(`/api/buildings/${id}/floor-plan${extra}`);
  }
  const h = window.location.hostname;
  const onSmartBuildingsIot =
    h === "iot.smarterbuildings.ca" ||
    h.includes("smarterbuildings.ca") ||
    h === "iot.smart-buildings.ca" ||
    h === "iot.smart.buildings.ca" ||
    h.includes("smart-buildings.ca") ||
    h.includes("smart.buildings.ca");
  if (onSmartBuildingsIot) {
    const proto = window.location.protocol || "https:";
    const base = h.includes("smarterbuildings.ca")
      ? `${proto}//iot.smarterbuildings.ca`
      : `${proto}//iot.smart-buildings.ca`;
    return `${base}/api/buildings/${id}/floor-plan${extra}`;
  }
  return buildApiUrl(`/api/buildings/${id}/floor-plan${extra}`);
}

function getFloorPlansCollectionUrl(buildingId, planId = null, markers = false) {
  const id = encodeURIComponent(String(buildingId ?? "").trim());
  let path = `/api/buildings/${id}/floor-plans`;
  if (planId != null) path += `/${encodeURIComponent(String(planId))}`;
  if (markers) path += `/markers`;
  if (typeof window === "undefined") {
    return buildApiUrl(path);
  }
  const h = window.location.hostname;
  const onSmartBuildingsIot =
    h === "iot.smarterbuildings.ca" ||
    h.includes("smarterbuildings.ca") ||
    h === "iot.smart-buildings.ca" ||
    h === "iot.smart.buildings.ca" ||
    h.includes("smart-buildings.ca") ||
    h.includes("smart.buildings.ca");
  if (onSmartBuildingsIot) {
    const proto = window.location.protocol || "https:";
    const base = h.includes("smarterbuildings.ca")
      ? `${proto}//iot.smarterbuildings.ca`
      : `${proto}//iot.smart-buildings.ca`;
    return `${base}${path}`;
  }
  return buildApiUrl(path);
}

async function authFetch(url, options = {}) {
  const token = typeof window !== "undefined" ? localStorage.getItem("authToken") : null;
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
  });
}

async function readErrorMessage(res, fallback) {
  let msg = fallback || `${res.status} ${res.statusText}`;
  try {
    const j = await res.json();
    msg = j.message || j.error || msg;
  } catch {
    // ignore
  }
  return msg;
}

/** List floor plans for a building. Returns { floorPlans: [...], floorPlanCount }. */
export async function fetchBuildingFloorPlans(buildingId) {
  const url = getFloorPlansCollectionUrl(buildingId);
  const res = await authFetch(url);
  if (res.status === 404) return { floorPlans: [], floorPlanCount: 0 };
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return res.json();
}

/** Download one floor plan file by id. Returns null if 404. */
export async function fetchBuildingFloorPlanBlobById(buildingId, planId) {
  const url = getFloorPlansCollectionUrl(buildingId, planId);
  if (typeof window !== "undefined" && FLOOR_PLAN_DEBUG) {
    console.log("[floor-plan] GET plan", { url, buildingId, planId });
  }
  const res = await authFetch(url);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(await readErrorMessage(res));
  const blob = await res.blob();
  const mimeType = res.headers.get("Content-Type") || blob.type || "";
  return { blob, mimeType };
}

/** Download floor plan file (legacy: first plan). Returns null if 404. */
export async function fetchBuildingFloorPlanBlob(buildingId) {
  const url = getFloorPlanResourceUrl(buildingId);
  if (typeof window !== "undefined" && FLOOR_PLAN_DEBUG) {
    console.log("[floor-plan] GET", { url, buildingId });
  }
  const res = await authFetch(url);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return res.blob();
}

/** Upload an additional floor plan (PDF or image). Level 5 only. */
export async function uploadBuildingFloorPlan(buildingId, file, title = "") {
  const url = getFloorPlansCollectionUrl(buildingId);
  if (typeof window !== "undefined" && FLOOR_PLAN_DEBUG) {
    console.log("[floor-plan] POST", {
      url,
      buildingId,
      fileName: file?.name,
      fileSize: file?.size,
      fileType: file?.type,
      title,
    });
  }
  const form = new FormData();
  form.append("file", file);
  if (title) form.append("title", title);
  const res = await authFetch(url, { method: "POST", body: form });
  if (!res.ok) {
    if (res.status === 404) throw new Error(FLOOR_PLAN_NOT_ON_SERVER_MSG);
    throw new Error(await readErrorMessage(res));
  }
  return res.json();
}

/** Remove one floor plan by id (level 5). */
export async function deleteBuildingFloorPlanById(buildingId, planId) {
  const url = getFloorPlansCollectionUrl(buildingId, planId);
  const res = await authFetch(url, { method: "DELETE" });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  try {
    return await res.json();
  } catch {
    return { success: true };
  }
}

/** Remove all floor plans for a building (legacy). */
export async function deleteBuildingFloorPlan(buildingId) {
  const url = getFloorPlanResourceUrl(buildingId);
  if (typeof window !== "undefined" && FLOOR_PLAN_DEBUG) {
    console.log("[floor-plan] DELETE all", { url, buildingId });
  }
  const res = await authFetch(url, { method: "DELETE" });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  try {
    return await res.json();
  } catch {
    return { success: true };
  }
}

/** Rename a floor plan (level 5). */
export async function renameBuildingFloorPlan(buildingId, planId, title) {
  const url = getFloorPlansCollectionUrl(buildingId, planId);
  const res = await authFetch(url, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return res.json();
}

/**
 * Sensor icon positions on a specific floor plan (normalized 0..1 coords).
 * Returns { markers: [{ devEui, x, y, page }] }.
 */
export async function fetchFloorPlanMarkers(buildingId, planId = null) {
  const url =
    planId != null
      ? getFloorPlansCollectionUrl(buildingId, planId, true)
      : `${getFloorPlanResourceUrl(buildingId)}/markers`;
  const res = await authFetch(url);
  if (res.status === 404) return { markers: [] };
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return res.json();
}

/**
 * Replace sensor icon positions for a floor plan (level 5).
 * markers: [{ devEui, x, y, page? }] with x/y normalized 0..1.
 */
export async function saveFloorPlanMarkers(buildingId, markers, planId = null) {
  const url =
    planId != null
      ? getFloorPlansCollectionUrl(buildingId, planId, true)
      : `${getFloorPlanResourceUrl(buildingId)}/markers`;
  const res = await authFetch(url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ markers: Array.isArray(markers) ? markers : [] }),
  });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return res.json();
}

// Building assignment functions
export const assignBuildingToUser = async (userId, buildingId) => {
  try {
    return await jsonFetch(`/api/users/${encodeURIComponent(userId)}/buildings`, {
      method: 'POST',
      body: JSON.stringify({ buildingId }),
    });
  } catch (err) {
    // If endpoint doesn't exist yet, show helpful error
    if (err.message && err.message.includes('404')) {
      throw new Error('Building assignment endpoints not yet implemented in central server. Please contact administrator.');
    }
    throw err;
  }
};

export const removeBuildingFromUser = async (userId, buildingId) => {
  try {
    return await jsonFetch(`/api/users/${encodeURIComponent(userId)}/buildings/${encodeURIComponent(buildingId)}`, {
      method: 'DELETE',
    });
  } catch (err) {
    if (err.message && err.message.includes('404')) {
      throw new Error('Building assignment endpoints not yet implemented in central server. Please contact administrator.');
    }
    throw err;
  }
};

export const getUserBuildings = async (userId) => {
  try {
    return await jsonFetch(`/api/users/${encodeURIComponent(userId)}/buildings`);
  } catch (err) {
    // If endpoint doesn't exist yet, return empty array
    if (err.message && err.message.includes('404')) {
      return { buildings: [] };
    }
    throw err;
  }
};

/** Level 4+: list sensor categories for a building (includes device membership). */
export const getSensorCategories = (buildingId) =>
  jsonFetch(`/api/buildings/${encodeURIComponent(buildingId)}/sensor-categories`);

/** Level 5: create a named category under one building. */
export const createSensorCategory = (buildingId, name) =>
  jsonFetch(`/api/buildings/${encodeURIComponent(buildingId)}/sensor-categories`, {
    method: 'POST',
    body: JSON.stringify({ name }),
  });

export const renameSensorCategory = (categoryId, name) =>
  jsonFetch(`/api/sensor-categories/${encodeURIComponent(categoryId)}`, {
    method: 'PATCH',
    body: JSON.stringify({ name }),
  });

export const deleteSensorCategory = (categoryId) =>
  jsonFetch(`/api/sensor-categories/${encodeURIComponent(categoryId)}`, {
    method: 'DELETE',
  });

/** Level 5: replace category device membership (exclusive — device cannot be in two categories). */
export const setSensorCategoryDevices = (categoryId, devEuis) =>
  jsonFetch(`/api/sensor-categories/${encodeURIComponent(categoryId)}/devices`, {
    method: 'PUT',
    body: JSON.stringify({ devEuis }),
  });

export const getUserSensorAccess = (userId, buildingId) =>
  jsonFetch(
    `/api/users/${encodeURIComponent(userId)}/buildings/${encodeURIComponent(buildingId)}/sensor-access`
  );

/**
 * Level 4+: replace sensor ACL for user+building.
 * payload: { allSensors?: boolean, categories?: [{categoryId, canControl}], devices?: [{devEui, canControl}] }
 */
export const putUserSensorAccess = (userId, buildingId, payload) =>
  jsonFetch(
    `/api/users/${encodeURIComponent(userId)}/buildings/${encodeURIComponent(buildingId)}/sensor-access`,
    {
      method: 'PUT',
      body: JSON.stringify(payload || {}),
    }
  );

export const getUserFloorPlanAccess = (userId, buildingId) =>
  jsonFetch(
    `/api/users/${encodeURIComponent(userId)}/buildings/${encodeURIComponent(buildingId)}/floor-plan-access`
  );

/** Level 4+: replace which floor plans a user may view for a building. payload: { floorPlanIds: number[] } */
export const putUserFloorPlanAccess = (userId, buildingId, payload) =>
  jsonFetch(
    `/api/users/${encodeURIComponent(userId)}/buildings/${encodeURIComponent(buildingId)}/floor-plan-access`,
    {
      method: 'PUT',
      body: JSON.stringify(payload || {}),
    }
  );

// ----------------- Thermostat command groups -----------------
export const getThermostatGroups = (buildingId) =>
  jsonFetch(`/api/buildings/${encodeURIComponent(buildingId)}/thermostat-groups`);

export const createThermostatGroup = (buildingId, name) =>
  jsonFetch(`/api/buildings/${encodeURIComponent(buildingId)}/thermostat-groups`, {
    method: 'POST',
    body: JSON.stringify({ name }),
  });

export const renameThermostatGroup = (groupId, name) =>
  jsonFetch(`/api/thermostat-groups/${encodeURIComponent(groupId)}`, {
    method: 'PATCH',
    body: JSON.stringify({ name }),
  });

export const deleteThermostatGroup = (groupId) =>
  jsonFetch(`/api/thermostat-groups/${encodeURIComponent(groupId)}`, {
    method: 'DELETE',
  });

export const setThermostatGroupDevices = (groupId, devEuis) =>
  jsonFetch(`/api/thermostat-groups/${encodeURIComponent(groupId)}/devices`, {
    method: 'PUT',
    body: JSON.stringify({ devEuis }),
  });

/** Bulk command: single or multi { commandType, temperature?, mode?, controlMode?, fanMode?, include*? } */
export const sendThermostatGroupCommand = (groupId, payload) =>
  jsonFetch(`/api/thermostat-groups/${encodeURIComponent(groupId)}/command`, {
    method: 'POST',
    body: JSON.stringify(payload || {}),
  });

/** Group membership + inherited schedules for one thermostat */
export const getThermostatGroupContext = (devEui) =>
  jsonFetch(`/api/thermostat/${encodeURIComponent(devEui)}/group-context`);

export const getThermostatGroupSchedules = (groupId) =>
  jsonFetch(`/api/thermostat-groups/${encodeURIComponent(groupId)}/schedules`);

export const createThermostatGroupSchedule = (groupId, schedule) =>
  jsonFetch(`/api/thermostat-groups/${encodeURIComponent(groupId)}/schedules`, {
    method: 'POST',
    body: JSON.stringify(schedule || {}),
  });

export const updateThermostatGroupSchedule = (groupId, scheduleId, patch) =>
  jsonFetch(
    `/api/thermostat-groups/${encodeURIComponent(groupId)}/schedules/${encodeURIComponent(scheduleId)}`,
    { method: 'PUT', body: JSON.stringify(patch || {}) }
  );

export const deleteThermostatGroupSchedule = (groupId, scheduleId) =>
  jsonFetch(
    `/api/thermostat-groups/${encodeURIComponent(groupId)}/schedules/${encodeURIComponent(scheduleId)}`,
    { method: 'DELETE' }
  );

export const getUserThermostatGroupAccess = (userId, buildingId) =>
  jsonFetch(
    `/api/users/${encodeURIComponent(userId)}/buildings/${encodeURIComponent(buildingId)}/thermostat-group-access`
  );

/** payload: { groups: [{ groupId, canControl }] } */
export const putUserThermostatGroupAccess = (userId, buildingId, payload) =>
  jsonFetch(
    `/api/users/${encodeURIComponent(userId)}/buildings/${encodeURIComponent(buildingId)}/thermostat-group-access`,
    {
      method: 'PUT',
      body: JSON.stringify(payload || {}),
    }
  );

// Get available buildings (server filters by IoT level / org / assignments)
export const getBuildings = async () => {
  try {
    const data = await jsonFetch('/api/buildings');
    const buildings = Array.isArray(data) ? data : data?.buildings || [];
    return { buildings };
  } catch (err) {
    if (err.message && err.message.includes('404')) {
      return { buildings: [] };
    }
    throw err;
  }
};

// ==================== Controller I/O & Automations ====================

/** Controllers with configurable terminals. Omit buildingId for every visible building. */
export const getControllers = (buildingId) =>
  jsonFetch(
    buildingId && buildingId !== "all"
      ? `/api/controllers?buildingId=${encodeURIComponent(buildingId)}`
      : `/api/controllers`
  );

export const getDevicePoints = (devEui) =>
  jsonFetch(`/api/devices/${encodeURIComponent(devEui)}/points`);

/** Every point in a building, grouped by device — backs the automation pickers. */
export const getBuildingPoints = (buildingId) =>
  jsonFetch(`/api/buildings/${encodeURIComponent(buildingId)}/points`);

/** Level 3 (internal 5): save what is physically wired to a terminal. */
export const updateDevicePointMapping = (devEui, pointKey, patch) =>
  jsonFetch(`/api/devices/${encodeURIComponent(devEui)}/points/${encodeURIComponent(pointKey)}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });

/** Manual output control. `value` sends a one-off command; `mode` sets the override. */
export const commandDevicePoint = (devEui, pointKey, body) =>
  jsonFetch(`/api/devices/${encodeURIComponent(devEui)}/points/${encodeURIComponent(pointKey)}/command`, {
    method: "POST",
    body: JSON.stringify(body),
  });

export const getAutomations = (buildingId) =>
  jsonFetch(`/api/buildings/${encodeURIComponent(buildingId)}/automations`);

export const createAutomation = (buildingId, automation) =>
  jsonFetch(`/api/buildings/${encodeURIComponent(buildingId)}/automations`, {
    method: "POST",
    body: JSON.stringify(automation),
  });

export const updateAutomation = (ruleId, patch) =>
  jsonFetch(`/api/automations/${encodeURIComponent(ruleId)}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });

export const deleteAutomation = (ruleId) =>
  jsonFetch(`/api/automations/${encodeURIComponent(ruleId)}`, { method: "DELETE" });

export const setAutomationEnabled = (ruleId, enabled) =>
  jsonFetch(`/api/automations/${encodeURIComponent(ruleId)}/${enabled ? "enable" : "disable"}`, {
    method: "POST",
  });

export const getAutomationActivity = (params = {}) => {
  const query = new URLSearchParams();
  if (params.ruleId) query.set("ruleId", params.ruleId);
  if (params.limit) query.set("limit", params.limit);
  const qs = query.toString();
  return jsonFetch(`/api/automations/activity${qs ? `?${qs}` : ""}`);
};

export const getAdminAudit = (params = {}) => {
  const query = new URLSearchParams();
  if (params.category) query.set("category", params.category);
  if (params.search) query.set("search", params.search);
  if (params.buildingId) query.set("buildingId", params.buildingId);
  if (params.limit) query.set("limit", String(params.limit));
  const qs = query.toString();
  return jsonFetch(`/api/admin/audit${qs ? `?${qs}` : ""}`);
};

export const getAdminServerLogs = (params = {}) => {
  const query = new URLSearchParams();
  if (params.limit) query.set("limit", String(params.limit));
  const qs = query.toString();
  return jsonFetch(`/api/admin/server-logs${qs ? `?${qs}` : ""}`);
};

export const fetchWaterSafetyZones = () => jsonFetch(`/api/water-safety/zones`);


export function zoneForDevEui(zonesOrPayload, devEui) {
  const eui = String(devEui || "").trim().toLowerCase();
  const zones = Array.isArray(zonesOrPayload)
    ? zonesOrPayload
    : Array.isArray(zonesOrPayload?.zones)
      ? zonesOrPayload.zones
      : [];
  if (!eui) return null;
  return zones.find((zone) =>
    (zone.assignments || []).some((assignment) => String(assignment.devEui || "").toLowerCase() === eui)
  ) || null;
}

export function formatWaterSafetyTimeout(timeout) {
  const status = String(timeout?.status || "").toLowerCase();
  if (!status) return "Not assigned";
  if (status === "idle") return "Idle";
  if (status === "cancelled") return "Cancelled";
  if (status === "expired") return "Expired";
  if (status === "running" && timeout?.expiresAt) {
    const remaining = new Date(timeout.expiresAt).getTime() - Date.now();
    if (!Number.isFinite(remaining)) return "Running";
    if (remaining <= 0) return "Expired";
    const hours = Math.floor(remaining / 3600000);
    const minutes = Math.max(1, Math.ceil((remaining % 3600000) / 60000));
    return `${hours}h ${minutes}m remaining`;
  }
  return status || "Unknown";
}

export function formatWaterSafetyValve(value) {
  if (value == null || value === "") return "Unknown";
  const normalized = String(value).trim().toLowerCase();
  if (normalized === "open") return "Open";
  if (normalized === "close" || normalized === "closed") return "Closed";
  return "Unknown";
}

export function formatWaterSafetyCommandStatus(status) {
  const normalized = String(status || "").trim().toLowerCase();
  if (normalized === "requested") return "Requested";
  if (normalized === "sent") return "Sent · valve has not moved";
  if (normalized === "accepted") return "Accepted · waiting for status";
  if (normalized === "failed") return "Failed";
  if (normalized === "confirmed") return "Confirmed";
  if (normalized === "timed_out") return "Timed out";
  return "None";
}

// Expose helpers to change/read base at runtime (no rebuild needed)
export const API = {
  get base() { return API_BASE; },
  setBase(next) {
    if (typeof window !== "undefined") {
      if (next) window.localStorage.setItem("API_BASE", next);
      else window.localStorage.removeItem("API_BASE");
      window.location.reload();
    }
  },
};

// Optional explicit export
export { API_BASE };
